import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { InternalNewsList } from '~/features/InternalNewsList';
import styles from './styles.module.scss';

/**
 * 社内報一覧 Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='社内報' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <InternalNewsList />
        </Suspense>
      </main>
    </div>
  </div>
);
